export default __webpack_public_path__ + "static/media/Slice 3.301d726c.svg";